export const ADD_LEAVE_TYPE = 'ADD_LEAVE_TYPE';
export const GET_LEAVE_TYPE = 'GET_LEAVE_TYPE';
export const REMOVE_LEAVE_TYPE = 'REMOVE_LEAVE_TYPE';
export const UPDATE_LEAVE_TYPE = 'UPDATE_LEAVE_TYPE';

export const ADD_LEAVE_REQUEST = 'ADD_LEAVE_REQUEST';
export const GET_REQUEST = 'GET_REQUEST';
export const APPROVE_REQUEST = 'APPROVE_REQUEST';
export const REJECT_REQUEST = 'REJECT_REQUEST';
